import { onFormChange } from './form-hook';

export const mappingHooks = [onFormChange];
